import React from 'react'
import { PublicLayout } from 'app/livbrite/components/PublicLayout'
import { useCmsBlock } from 'lib/core/hooks'
import { CMS_BLOCK } from 'app/livbrite/resources/constants'
import { Wrapper } from './styled'

export const NoResults = () => {
  const staticBlockID = CMS_BLOCK.PS_NO_RESULTS
  const staticBlock = useCmsBlock({
    id: staticBlockID,
    isLazy: true

  })

  return (
    <PublicLayout className='survey-results'>
      {staticBlock.content && (
        <Wrapper
          dangerouslySetInnerHTML={{
            __html: staticBlock.content
          }}
        />
      )}
    </PublicLayout>
  )
}
